export const SUP_ABOUT_US_PRESS_RELEASES_LOADER = {
  desktop: `
<div class="cui cui-grid">
  <div class="cui-container display-none display-lg-block">
    <div class="cui-skeleton-paragraph -spacing--bottom-40 -spacing--top-40">
      <div class="cui-skeleton-paragraph__content" style="width: 100%">
        <div class="cui-skeleton__item" style="height: 16px"></div>
      </div>
    </div>
    <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--desktop">
      <div class="cui-skeleton-heading__content" style="width: 50%">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>
    <!--Grid title -->
    <div class="cui-row -spacing--bottom-40">
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 420px; height: 32px"></div>
        </div>
      </div>
    </div>
    <!-- Press releases grid -->
    <div class="cui-row" >
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        </div>
      </div>
    </div>
    <!-- Load more -->
    <div class="cui-row -spacing--top-16" style="display: flex; flex-direction: column; justify-content: center; align-content: center; width: 100%">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16" style="align-self: center;">
        <div class="cui-skeleton__item" style="width: 110px; height: 26px"></div>
      </div>
      <div class="cui-skeleton-button -size--large">
        <div class="cui-skeleton-button__content" style="width: 180px">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
`
};
